<template>
    <div>
        <v-container id="SeguimientoAddMov">
            <v-card flat>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                        <v-card flat class="text-xs-center mt-8" width="100%" height="auto">
                            <v-card-title class="justify-center primary">
                                <v-toolbar-title id="titulocard">Agregar Movimiento</v-toolbar-title>
                                <v-icon>mdi-badge-account-alert</v-icon>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="full-height">
                                <v-row justify="center" class="mt-2">
                                    <v-col cols="12" lg="6">
                                        <vs-list>
                                            <span style="color: black; text-align: center">
                                                Tipo:
                                            </span>
                                            <vs-list-item :subtitle="tipo"> </vs-list-item>
                                        </vs-list>
                                        <!--<vs-list class="mt-2">
                                          <span style="color: black; text-align: center">
                                            Respuesta:</span
                                          >
                                          <br />
                                          <span> {{ this.yes == true ? "SI" : "NO" }} </span>
                                        </vs-list>-->
                                    </v-col>
                                </v-row>

                                <v-row justify="center" class="my-2">
                                    <v-col cols="12" lg="6">
                                        <vs-list>
                                            <span style="color: black; text-align: center">
                                                Observaciones:
                                            </span>
                                            <v-form v-model="valid" ref="form" lazy-validation>
                                                <v-textarea v-model="desc"
                                                            @input="uppercase()"
                                                            outlined
                                                            :rules="descRules"
                                                            counter
                                                            hint="Minimo: 12 Caracteres, Maximo: 500"></v-textarea>
                                            </v-form>
                                        </vs-list>
                                    </v-col>
                                </v-row>

                                <div class="mt-10"></div>

                                <v-row justify="center" class="mb-8">
                                    <v-btn class="ma-2"
                                           :loading="loading2"
                                           :disabled="!valid"
                                           color="primary"
                                           @click="RegistrarMovimiento()">
                                        Guardar
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>
                                    <v-btn class="ma-2" @click="clearForm()"> Limpiar </v-btn>

                                    <v-btn class="ma-2" color="error" @click="$router.go(-1)">
                                        Cancelar
                                    </v-btn>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import { mapActions, mapState } from "vuex";
    import seguimientoService from "@/services/Seguimiento/seguimiento.service.js";
    import Documentos from '@/services/Documentos/documentos.service.js';
    import ListaDocumentos from "@/components/pages/GestoriaDoc/ListaDocumentos.vue";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import moment from "moment";

    export default {
        components: {
            ListaDocumentos,
        },
        data() {
            return {
                tipoAsistencia: [],

                docs: [],

                loading2: null,
                loading: null,
                date: null,

                desc: "",
                tipo: "",
                minDate: null,
                maxDate: null,
                fechaSelected: null,
                descRules: [
                    (v) => !!v || "DEBE AGREGAR UNA DESCRIPCIÓN",
                    (v) =>
                        (v && v.length >= 12) ||
                        "LA DESCRIPCIÓN DEBE SER MAYOR A 12 CARACTERES",
                    (v) =>
                        (v && v.length <= 500) ||
                        "LA DESCRIPCIÓN DEBE SER MENOR A 500 CARACTERES",
                ],

                recepDocIds: [],

                valid: true,
                yes: null,
                validaConclusion: false,
            };
        },
        props: ["tAsistencia", "nrreporte", "svindice"],
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
        },
        watch: {},
        mounted() {
            
            //console.log("El parametro bro: ", this.$route.params.opc , "el valor bro: ", this.$route.params.valor);
            this.obtenerEstadoReporte();
            this.ObtenenerDatosMovimiento();
        },
        methods: {
            async obtenerEstadoReporte() {
                this.validaConclusion = await MetodosGenerales.getReporteEstatus(this);
                if (this.validaConclusion == false) {
                    this.goBackTo();
                }
            },

            async getYesAswered() {
                this.recepDocIds = [];
                this.docs.forEach((element) => {
                    for (const [key, value] of Object.entries(element)) {
                        if (value == undefined) {
                            element[key] = null;
                        }
                        if (key == "gdrecepfisc" && value == true) {
                            this.recepDocIds.push(element["gdid"]);
                        }
                    }
                });
            },

            uppercase() {
                this.desc = this.desc.toUpperCase();
            },

            goBackTo() {
                this.$router.push({ name: "ReporteSeguimientoGD" });
            },

            clearForm() {
                let today = moment().format("YYYY[-]MM[-]DD HH:mm");
                this.fechaSelected = today;
                this.desc = "";
            },

            async ObtenenerDatosMovimiento() {
                //let reporte = JSON.parse(sessionStorage.getItem("reporte"));
                let reporte = await MetodosGenerales.obtenerSessionReporte('reporte');
                var respuesta = await seguimientoService.ObtenerDatosMovimientos(
                    reporte.nrreporte,
                    reporte.svindice,
                    this.$route.params.opc
                );
                this.tipo = respuesta.TipoMovimiento.toUpperCase();
                moment.locale("en");
                let auxMaxDate = moment().format("YYYY[-]MM[-]DD");
                this.maxDate = auxMaxDate;
                let today = moment().format("YYYY[-]MM[-]DD HH:mm");
                this.fechaSelected = today;
                let auxMinDate = respuesta.FechaReporte;
                this.minDate = auxMinDate.slice(0, 10);

                if ([818, 820, 823].includes(this.$route.params.opc)) {
                    if (this.$route.params.valor == 3) {
                        this.yes = true;
                    }
                } else {
                    if (this.$route.params.valor == 1) {
                        this.yes = true;
                    }
                }
            },

            async RegistrarMovimiento() {

                console.log("En el guardar");
                this.desc = this.desc.trim();
                this.$refs.form.validate();
                //if (this.desc.length < 12) {
                //    return;
                //}
                if (this.$refs.form.validate()) {
                    //let reporte = JSON.parse(sessionStorage.getItem("reporte"));
                    let reporte = await MetodosGenerales.obtenerSessionReporte('reporte');
                    let exresp = null;

                    this.$swal({
                        title: "Cargando...",
                        html: "Añadiendo movimiento por favor espere",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    this.$swal.showLoading();
                    this.getYesAswered();
                    var formData = new FormData();
                    formData.append("nrreporte", reporte.nrreporte);
                    formData.append("svindice", reporte.svindice);
                    formData.append("obs", this.desc);

                    Documentos.AgregarMovRecepFis(this, formData).then(data => {
                        console.log(data);
                        if (data == true) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito",
                                text: "Se agregó el movimiento correctamente",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                confirmButtonText: "Ok!",
                            }).then(() => {
                                this.$router.push({ name: `DocumentosView` });
                            });
                        } else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error",
                                text: "No se pudo realizar el movimiento por favor intente de nuevo mas tarde, si el problema persiste ponganse en contacto con el equipo de asistencia tecnica",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                confirmButtonText: "Ok!",
                            });
                        }
                    });

                }



            },
        },
    };
</script>

<style>
    #SeguimientoAddMov .vs-list--title {
        font-size: 0.8rem !important;
        font-weight: 700 !important;
    }

    #SeguimientoAddMov .vs-list--subtitle {
        font-size: 1.3rem !important;
        font-weight: 700 !important;
    }

    .full-height {
        height: auto;
    }
</style>